import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import styled, {keyframes} from 'styled-components';
import {Contents, DropdownMenu, Overlay} from "../../../components";
import {CheckBox} from "../../../components/common/CheckBox";
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import RemoveGrey from "../../../../assets/images/icon/RemoveGrey";
import {AddChapter, FormItem} from "../../../../styled/StyledComponent";
import PlusIcon from "../../../../assets/images/icon/PlusIcon";
import Picker from "../../../components/common/Picker";
import {cloneDeep, filter} from "lodash";
import {isEmpty, textTransform} from "../../../../util";
import CalendarPopup from "./CalendarPopup";
import {SpacingV} from "../../InstructorApp/component/common/Spacing";
import CalendarView from "./CalendarView";
import dayjs from "dayjs";
import hashIt from "hash-it";
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import {liveAPI} from "../../../../api/liveAPI";
import moment from "moment-timezone";
import AutoComplete from "../../InstructorApp/component/common/AutoComplete";
import MainLogo from "../../../../assets/images/icon/MainLogo";
import {useNavigate} from "react-router-dom";

function padZero(num) {
  // 숫자를 문자열로 변환하여 앞에 0을 추가
  return num < 10 ? '0' + num : num.toString();
}
const hourArr = () => {
  let arr = []
  for(let i = 0; i < 24; i++){
    arr.push(padZero(i))
  }
  return arr
}
const minArr = () => {
  let arr = []
  for(let i = 0; i < 12; i++){
    arr.push(padZero(5 * i))
  }
  return arr
};

const dayOfWeekOrder = {
  "MONDAY": 1,
  "TUESDAY": 2,
  "WEDNESDAY": 3,
  "THURSDAY": 4,
  "FRIDAY": 5,
  "SATURDAY": 6,
  "SUNDAY": 7
};

const fadeIn = keyframes`
  from {
    transform: translateY(-10px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: translateY(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

const fadeIn2 = keyframes`
  from {
    
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

const fadeIn3 = keyframes`
  from {
    transform: translate(-52%, -50%) ;
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: translate(-50%, -50%) ;
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

// 스타일드 컴포넌트 생성
const AnimatedDiv = styled.div`

`;
const timeZones = moment.tz.names();


const PickerWrap = (props:any) => {
  const { time, onChange } = props;
  const [on, setOn] = useState(false);
  const itemRef = useRef(null)
  const pickerRef = useRef(null);
  const [value, setValue] = useState("")
  const [view, setView] = useState(false)
  

  const handleInputFocus = () => {
    setOn(true);
  };

  const handleClosePopup = (e) => {
    // 팝업 외부를 클릭하거나 다른 입력란을 클릭했을 때 팝업을 닫습니다.
    if (!pickerRef.current.contains(e.target)) {
      setOn(false);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target) && !itemRef.current.contains(event.target)) {
        setOn(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  useEffect(() => {
    if(itemRef.current){
      itemRef.current.value = time?.replace(":", " : ")
    }
  }, [time]);


  return(
      <FormItem className={"form"}>
        <input
            style={{
              border:props?.warn ? "solid 1px rgb(215,47,41)" : ""
            }}
            ref={itemRef}
            onFocus={(event)=>{
              event.stopPropagation();
              handleInputFocus();
            }}
            readOnly={true}
            required={true}
            onClick={(e)=>{
              e.stopPropagation()
            }}

            // value={time.endTime === "00" && time.startTime === "00" ? "" : `${time.startTime} : ${time.endTime}`}
        />
        <PickerPopup
            className={`${on ? "on" : ""}`}
            onClick={handleClosePopup}
            ref={pickerRef}
        >
          <Picker list={[...hourArr()]} onSelectedChange={(v)=>{

            onChange(true, v)
          }}/>
          <Picker list={[...minArr()]} onSelectedChange={(v)=>{

            onChange(false, v)
          }}/>
        </PickerPopup>

      </FormItem>

  )
}

const testObj = {
  startTime:"00:00",
  endTime:"00:00"
}

const tD = [
  {
    "dayOfWeek": "MONDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "TUESDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "WEDNESDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "THURSDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "FRIDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "SATURDAY",
    "times": [

    ]
  },
  {
    "dayOfWeek": "SUNDAY",
    "times": [

    ]
  }
]
const timezoneSt = Intl.DateTimeFormat().resolvedOptions().timeZone;
const ManageSchedule = (props) => {
  const [weekItem, setWeekItem] = useState(tD);
  const [userTimeZone, setUserTimeZone] = useState(null);
  const [calPopup, setCalPopup] = useState(false);
  const [customData , setCustomData] = useState([]);
  const [timezoneValue, setTimezone] = useState(`${timezoneSt || ""}`)
  const [popupDate, setPopupDate ] = useState(new Date());
  const [view, setView] = useState(false)
  const [weeklyPopup, setWeeklyPopup] = useState(false);
  const [prevWeeklyData, setPrevWeeklyData] = useState(null)
  const [configPopup, setConfigPopup] = useState(false);
  const [sucAlert, setSucAlert] = useState(false);
  const [bufferTime, setBufferTime] = useState(0);
  const [dailyLimit, setDailyLimit] = useState(0);
  const [increments, setIncrements] = useState(0);
  const [customIncrements, setCustomIncrements] = useState({
    type:"Min",
    value:0
  })
  function getCurrentTimezoneAndOffset() {
    const currentTimezone = new Date().getTimezoneOffset() / 60; // 시간대 오프셋을 시간 단위로 변환
    const currentOffset = currentTimezone * 60; // 분 단위로 변환

    return {
      timezone: currentTimezone,
      offset: currentOffset
    };
  }
  const { timezone, offset } = getCurrentTimezoneAndOffset();


  const getManageSchedule = async () => {
    await liveAPI.getTimeSetting()
        .then(result => {
            const res = result?.data
            if(!isEmpty(res)){
              console.log("@res",res);
              if(!isEmpty(res?.increments)){
                setIncrements(res?.increments);
              }else{
                setIncrements(0)
              }
              if(!isEmpty(res?.dailyLimit)){
                setDailyLimit(res?.dailyLimit);
              }else{
                setDailyLimit(0)
              }
              if(!isEmpty(res?.bufferTime)){
                setBufferTime(res?.bufferTime);
              }else{
                setBufferTime(0)
              }
              if(!isEmpty(res?.timeZone)){
                setTimezone(res?.timeZone);
              }else{
                setTimezone(timezoneSt)
              }
              const weeks = JSON.parse(res?.weeks);
              const days = JSON.parse(res?.days);
              console.log("@weeks",weeks);
              console.log("@days",days);
              const weekData = Object.entries(weeks)?.map(item => {
                return {
                  dayOfWeek:item[0],
                  // @ts-ignore
                  times:JSON.parse(item[1])
                }
              })
              const daysData =  Object.entries(days)?.map(item => {
                return {
                  date:item[0],
                  // @ts-ignore
                  times: JSON.parse(item[1])
                }
              })

              if(!isEmpty(weekData)){
                const arr = cloneDeep(weekData)?.map((item) => {
                  const nTimes = item?.times?.map((timeItem) =>{
                    const spArr = timeItem?.split("~");
                    return {
                      startTime:spArr[0],
                      endTime:spArr[1]
                    };
                  })
                  return {
                    dayOfWeek:item?.dayOfWeek,
                    times:nTimes
                  }
                })

                const setData = cloneDeep(tD).map((item) => {
                  const check = arr.find((findItem) => {
                    return findItem.dayOfWeek === item.dayOfWeek
                  })
                  if(!isEmpty(check)){
                    item = check
                  }
                  return item;
                })
                setData.sort((a, b) => dayOfWeekOrder[a.dayOfWeek] - dayOfWeekOrder[b.dayOfWeek]);


                setWeekItem(cloneDeep(setData))
              };

              if(!isEmpty(daysData)){
                const arr = cloneDeep(daysData)?.map((item) => {
                  const nTimes = item?.times?.map((timeItem) =>{
                    const spArr = timeItem?.split("~");
                    return {
                      startTime:spArr[0],
                      endTime:spArr[1]
                    };
                  })
                  return {
                    date:item?.date,
                    times:nTimes
                  }
                })
                sortCustom(cloneDeep(arr))
              }


            }

        })
  }

  useEffect(() => {
    getManageSchedule()
  }, []);
  const onClickWeekItem = (add:boolean, day:string, index:any) => {
    const c = cloneDeep(weekItem);
    if(add){
      const findItem = c.find(item => {
        return item.dayOfWeek === day
      })
      findItem?.times?.push(testObj)
      setWeekItem(cloneDeep(c));
    }else{
      const findItem = c.find(item => {
        return item.dayOfWeek === day
      })
      if( findItem?.times?.length === 1) return;


      findItem?.times?.splice(index, 1);
      setWeekItem(cloneDeep(c));
    }
  };
  const onClickPopupDate = (value) => {
    setPopupDate(value)
  };


  const getConfigMinArr = () => {
    const arr = [...minArr(), '60'].map(item => {
      return {
        dropdownItem:`${item} min`,
        item:item
      }
    })
    return arr
  }

  const applyDate = () => {
    const c = cloneDeep(customData);
    const findItem = c.find(item => item.date === String(popupDate))
    if(!isEmpty(findItem)){

    }
    // setCustomData();
  };
  const customList = () => {
    const c = cloneDeep(customData);
    const custom = c.find(item => {
      return item.date === String(popupDate);
    });
    if(isEmpty(custom)){
      return {
        date:popupDate,
        times: [

        ]
      }
    }else{
      return custom;
    }
  };
  const addCustom = (add:boolean,index:any, date) => {
    const c = cloneDeep(customData);
    const custom = c.find(item => {
      return item.date === String(date);
    });

    if(add){
      if(isEmpty(custom)){
        c.push(
            {
              "date": String(date),
              "times": [
                {
                  "endTime": "00:00",
                  "startTime": "00:00"
                }
              ]
            }
        )
      }else{
        custom.times.push({
          "endTime": "00:00",
          "startTime": "00:00"
        })
      }

      setCustomData(cloneDeep(c))
    }else{
      custom.times.splice(index,1)
      setCustomData(cloneDeep(c));
    }
  };
  const onClickMore = (date) => {
    const c = cloneDeep(customData)
    setPrevData(c)
    setPopupDate(date);
    setCalPopup(true);
  };

  const onClickCheckBox = (weekday) => {
    const c = cloneDeep(weekItem);
    const findItem = c.find(item => {
      return item.dayOfWeek === weekday
    })
    if(isEmpty(findItem.times)){
      findItem.times.push({
        "endTime": "00:00",
        "startTime": "00:00"
      })
    }else{
      findItem.times = []
    }
    setWeekItem(cloneDeep(c))
  };

  const returnCheckState = (weekday) => {
    const c = cloneDeep(weekItem);
    const findItem = c.find(item => {
      return item.dayOfWeek === weekday
    })
    return !isEmpty(findItem.times)
  };

  const sortCustom = (data:any) => {
    data.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateA - dateB;
    });

    data.forEach(item => {
      item.times.sort((a, b) => {
        const startTimeA = a.startTime;
        const startTimeB = b.startTime;
        return startTimeA.localeCompare(startTimeB);
      });
    });
    setCustomData(cloneDeep(data))
  };

  const returnCustomValue = () => {
    if(customIncrements.type === "Min"){
      return customIncrements.value
    }else{
      return customIncrements.value * 60
    }
  };

  const [arrCheckList, setArrCheckList] = useState([])
  const checkTimeSetting = (arr) => {
    const check = arr.filter((item) => {
      return item?.startTime >= item?.endTime
    })
    return check?.length
  }
  const checkOverlapSetting = (arr, time, start) => {
    const check3 = arr.filter(item => {

    })
    if(start){
      const check = arr.filter(item => {
        return item.startTime <= time && item.endTime > time
      });

      return check.length
    }else{
      const check = arr.filter(item => {
        return item.endTime >= time && item.startTime < time
      });

      return check.length
    }
  };

  // const findOverlap = (items) => {
  //   const c = cloneDeep(items);

  //   let arr = []
  //   items.forEach(item => {
  //     const check = items.filter((filterItem) => {
  //      return  filterItem.startTime === item.startTime;
  //     });
  //     const check2 = items.filter((filterItem)=>{
  //       return  filterItem.endTime === item.endTime;
  //     })
  //     const check3 = null
  //     if(check.length > 1 || check2.length > 1){
  //       arr = [...check]
  //     }
  //
  //   })

  //   return arr;
  // };

  const findOverlap = (items) => {
    const c = cloneDeep(items);

    let arr = [];
    items.forEach(item => {
      const overlaps = items.filter((filterItem) => {
        // Check if the current item's start time is within the range of any other item
        const withinStartTimeRange = filterItem.startTime < item.endTime && item.startTime < filterItem.endTime;
        // Exclude the current item itself from being considered as an overlap
        const notCurrentItem = filterItem !== item;
        return withinStartTimeRange && notCurrentItem;
      });
      if (overlaps.length > 0) {
        arr.push(item);
      }
    });

    return arr;
  };
  const putTimeSetting = async () => {
    // @ts-ignore
    const schSetting: {
      bufferTime?:number
      dailyLimit?:number
      startTimeIncrement?:number
    } = {

    };
    if(bufferTime !== 0){
      schSetting.bufferTime = bufferTime;
    };
    if(dailyLimit !== 0){
      schSetting.dailyLimit = dailyLimit;
    }
    if(increments !== 0 || isNaN(increments)){
      schSetting.startTimeIncrement = isNaN(increments) ? returnCustomValue() : increments
    }
    const checkTimeZone = timeZones.find(item => {
      return item === timezoneValue
    })

    await liveAPI.putTimeSetting({
      data:{
        dailies:cloneDeep(weekItem),
        days:cloneDeep(customData),
        "scheduleSettings": {
          "afterEvent": 0,
          "bufferTime": 0,
          "dailyLimit": 0,
          "startTimeIncrement": 0,
          ...schSetting
        },
        "timeZone":isEmpty(checkTimeZone) ? timezoneSt : timezoneValue
      }
    })
        .then(res => {
          setSucAlert(true)
          setTimeout(()=>{
            setSucAlert(false)
          },1500)

          getManageSchedule()
        })
  };

  const checkData = (arr, custom = false) => {
    const c = cloneDeep(arr);
    if(custom){
      console.log("@arr",arr);

      const check = c.filter(item => {
        return item.startTime >= item.endTime
      })

      return [...findOverlap(arr), ...check]
    }else{
      const f = c.filter((schItem, index) => {

        return !isEmpty(findOverlap(schItem?.times))
      })
      const check = c.filter(item => {
        const arr = item.times.filter((fItem) => {
          return fItem.startTime >= fItem.endTime
        })
        return !isEmpty(arr)
      })

      return [...f, ...check]
    }

  }

  const textRef = useRef(null);
  const navigate = useNavigate()
  const [totalWidthValue, setTotalWidth] = useState(0);
  const [prevData, setPrevData] = useState(null)

  useEffect(() => {
    if(textRef.current){
      const getTextWidth = (text) => {
        if(textRef){
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          context.font = window?.getComputedStyle(textRef.current).font;
          const metrics = context.measureText(text);
          return metrics.width;
        }
      };

      const totalWidth = timezoneValue.split('').reduce((acc, char) => {
        return acc + getTextWidth(char);
      }, 0);

      if(totalWidth !== 0){
        setTotalWidth(totalWidth)
      }
      const inputStyle = {
        width: `${totalWidth}px`,
      };


    }
  }, [textRef.current, timezoneValue]);

  console.log("@customList()?.times",customList()?.times);

  return(
      <Container>
        <Logo width={180 / 1440}>
          <MainLogo/>
          <div className="text"
            onClick={()=>{
              navigate("/main/live")
            }}
          >
            <svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M29.668 8.82812C30.2203 8.82813 30.668 8.38041 30.668 7.82813C30.668 7.27584 30.2203 6.82813 29.668 6.82812L29.668 8.82812ZM0.960861 7.12102C0.570337 7.51154 0.570337 8.1447 0.960861 8.53523L7.32482 14.8992C7.71535 15.2897 8.34851 15.2897 8.73904 14.8992C9.12956 14.5087 9.12956 13.8755 8.73904 13.485L3.08218 7.82812L8.73904 2.17127C9.12956 1.78074 9.12956 1.14758 8.73904 0.757055C8.34851 0.366531 7.71535 0.366531 7.32482 0.757055L0.960861 7.12102ZM29.668 6.82812L1.66797 6.82812L1.66797 8.82812L29.668 8.82812L29.668 6.82812Z"
                  fill="#333333"/>
            </svg>
            <span>
              Back
            </span>
          </div>
        </Logo>
        {
            sucAlert &&
            <SucPopup>
              <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M16.9684 5.03712C15.0479 4.18139 12.9023 3.9694 10.8514 4.43276C8.80063 4.89611 6.95453 6.00999 5.58849 7.60826C4.22244 9.20653 3.40964 11.2036 3.2713 13.3015C3.13296 15.3995 3.6765 17.486 4.82085 19.2498C5.9652 21.0136 7.64905 22.3602 9.62127 23.0888C11.5935 23.8175 13.7484 23.8891 15.7646 23.2929C17.7809 22.6968 19.5504 21.4649 20.8093 19.7809C22.0682 18.0969 22.749 16.0511 22.7502 13.9486V12.9526C22.7502 12.3543 23.2352 11.8692 23.8335 11.8692C24.4318 11.8692 24.9168 12.3543 24.9168 12.9526V13.9492C24.9154 16.519 24.0833 19.02 22.5446 21.0782C21.006 23.1364 18.8432 24.6421 16.379 25.3707C13.9147 26.0993 11.2809 26.0118 8.87041 25.1212C6.45992 24.2307 4.40188 22.5848 3.00322 20.429C1.60457 18.2733 0.940247 15.7231 1.10933 13.159C1.27841 10.5948 2.27183 8.15398 3.94145 6.20053C5.61106 4.24709 7.8674 2.88569 10.374 2.31936C12.8805 1.75304 15.503 2.01214 17.8503 3.05802C18.3968 3.30153 18.6424 3.94197 18.3989 4.48849C18.1554 5.035 17.5149 5.28063 16.9684 5.03712Z"
                      fill="#333333"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M24.5988 4.51614C25.0221 4.93899 25.0224 5.62492 24.5996 6.0482L13.7663 16.8924C13.5631 17.0957 13.2875 17.21 13.0001 17.2101C12.7127 17.2101 12.437 17.096 12.2338 16.8928L8.9838 13.6428C8.56074 13.2197 8.56074 12.5338 8.9838 12.1107C9.40687 11.6876 10.0928 11.6876 10.5159 12.1107L12.9995 14.5943L23.0668 4.5169C23.4896 4.09362 24.1755 4.09328 24.5988 4.51614Z"
                      fill="#333333"/>
              </svg>

            </SucPopup>
        }
        {
            calPopup &&
            <Overlay filter={true}>
              <PopupArea>
                <CalendarPopup
                    onClickPopupDate={onClickPopupDate}
                    customData={customData}
                    popupDate={popupDate}

                />
                <PopupContents>
                  <h5 style={{marginBottom: 15}}>
                    What hours are you available?
                  </h5>
                  <ContentsList>
                    <ContentsListItems>
                      {
                        !isEmpty(customList()?.times) ?
                            customList()?.times?.map((item, index) => {
                              return (
                                  <WeeklyItem
                                    className={"calPopup"}
                                  >
                                    <InputItems>
                                      <PickerWrap time={item?.startTime}
                                                  warn={
                                                      item?.startTime >= item?.endTime ||
                                                      findOverlap(customList()?.times).filter(filterItem => {
                                                        return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                      }).length > 0
                                                  }
                                                  onChange={
                                                    (hour: boolean, time) => {
                                                      const value = item?.startTime.split(":");
                                                      if (hour) {
                                                        value[0] = time
                                                      } else {
                                                        value[1] = time
                                                      }
                                                      const c = cloneDeep(customData);
                                                      const custom = c.find(item => {
                                                        return item.date === String(popupDate);
                                                      });
                                                      custom.times[index].startTime =`${value[0]}:${value[1]}`
                                                      setCustomData(cloneDeep(c))
                                                    }
                                                  }
                                      />
                                      <div className="line"></div>
                                      <PickerWrap
                                          warn={
                                              item?.startTime >= item?.endTime ||
                                              findOverlap(customList()?.times).filter(filterItem => {
                                                return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                              }).length > 0
                                          }
                                          time={item?.endTime}
                                          onChange={
                                            (hour:boolean, time)=>{
                                              const value = item?.endTime.split(":");
                                              if(hour) {
                                                value[0] = time
                                              }else {
                                                value[1] = time
                                              }
                                              const c = cloneDeep(customData);
                                              const custom = c.find(item => {
                                                return item.date === String(popupDate);
                                              });
                                              custom.times[index].endTime =`${value[0]}:${value[1]}`
                                              setCustomData(cloneDeep(c))
                                            }
                                          }
                                      />
                                      <div
                                          onClick={() => {
                                            addCustom(false, index, popupDate);
                                          }}
                                          className="delIcon icon">
                                        <DeleteIcon/>
                                      </div>
                                    </InputItems>
                                    {
                                        item?.startTime >= item?.endTime &&
                                        <p style={{
                                          color:"rgb(215,47,41)",
                                          marginLeft:0,
                                          marginTop:10,
                                          textAlign:"left",
                                          width:"100%"
                                        }}>Choose en end time later the start Time</p>
                                    }
                                    {
                                        findOverlap(customList()?.times).filter(filterItem => {
                                          return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                        }).length > 0 &&
                                        // (checkOverlapSetting(schItem?.times, item?.startTime, true) > 1 ||
                                        // checkOverlapSetting(schItem?.times, item?.endTime, false) > 1) &&
                                        <p style={{
                                          color: "rgb(215,47,41)",
                                          marginLeft: 0,
                                          marginTop: 10,
                                          textAlign:"left",
                                          width:"100%"
                                        }}>Times overlap with another set of times</p>
                                    }
                                  </WeeklyItem>
                              )
                            })
                            :
                            <div
                                style={{width:290}}
                            >
                              <SpacingV height={50} />
                            </div>
                      }
                    </ContentsListItems>

                    <AddButton
                        style={{ paddingBottom:10, paddingTop:10}}
                        onClick={()=>{
                          addCustom(true, null, popupDate);
                        }}
                        className={"on"}
                    >
                      <PlusIcon/>
                    </AddButton>
                  </ContentsList>
                </PopupContents>
                <PopupSave >
              <span
                  onClick={()=>{
                    sortCustom(cloneDeep(prevData))
                    setCalPopup(false)
                  }}
              >Cancel</span>
                  <span
                      className={!isEmpty(checkData(customList()?.times, true)) ? "none" : "" }
                      onClick={()=>{
                        if(!isEmpty(checkData(customList()?.times, true))) return;
                        setCalPopup(false)
                        sortCustom(cloneDeep(customData))
                      }}
                  >Apply</span>
                </PopupSave>
              </PopupArea>
            </Overlay>
        }
        {
          weeklyPopup &&
            <Overlay filter={true}>
              <PopupArea
                  className={"weeklyEdit"}
                  style={{
                    background:"#fff"
                  }}>
                <WeeklyItems>
                  <h4 style={{marginBottom:10, marginTop:20}}>Set Weekly hours</h4>
                  <WeeklyList  style={{marginBottom:0, height:500}}>
                    {
                      weekItem?.map((schItem, schIndex) => {


                        return(
                            <DaySch
                                className={`${isEmpty(schItem?.times) ? "empty" : ""}`}
                                style={{
                                  height: isEmpty(schItem?.times) ? 80 : schItem?.times?.length * 50 + 30
                                      + (checkTimeSetting(schItem.times) * 26 + (checkTimeSetting(schItem.times) !== 0 ? 8 : 0)) +
                                      (findOverlap(schItem.times).length * 26 + (findOverlap(schItem?.times)?.length !== 0 ? 8 : 0)),
                                  transition: "all 0.25s"
                                }}
                            >

                              {
                                isEmpty(schItem?.times) ?
                                    <WeeklyItem >
                                      <DayCheck className={"on"}
                                                onClick={()=>{
                                                  onClickCheckBox(schItem?.dayOfWeek)
                                                }}
                                      >
                                        <CheckBox
                                            onClick={()=>{
                                              onClickCheckBox(schItem?.dayOfWeek)
                                            }}
                                            state={returnCheckState(schItem?.dayOfWeek)}
                                        />
                                        <span>{textTransform().capitalizeFirstLetter(String(schItem?.dayOfWeek).toLocaleLowerCase())}</span>
                                      </DayCheck>

                                      <p>Not Available</p>
                                    </WeeklyItem>

                                    :
                                    schItem?.times?.map((item, index) => {
                                      // if(isEmpty(item.startTime)){
                                      //   const c = cloneDeep(weekItem);
                                      //   c[schIndex].times[index].startTime = `00:00`
                                      //   setWeekItem(cloneDeep(c))
                                      // }
                                      // if(isEmpty(item.endTime)){
                                      //   const c = cloneDeep(weekItem);
                                      //   c[schIndex].times[index].endTime = `00:00`
                                      //   setWeekItem(cloneDeep(c))
                                      // }
                                      return(
                                          <React.Fragment>
                                            <WeeklyItem >
                                              <DayCheck className={index === 0 ?"on" : ""}
                                                        onClick={()=>{
                                                          onClickCheckBox(schItem?.dayOfWeek)
                                                        }}
                                              >
                                                <CheckBox
                                                    onClick={()=>{
                                                      onClickCheckBox(schItem?.dayOfWeek)
                                                    }}
                                                    state={returnCheckState(schItem?.dayOfWeek)}
                                                />
                                                <span>{textTransform().capitalizeFirstLetter(String(schItem?.dayOfWeek).toLocaleLowerCase())}</span>
                                              </DayCheck>
                                              <InputItems>
                                                <PickerWrap time={item?.startTime}
                                                            warn={
                                                                item?.startTime >= item?.endTime ||
                                                                findOverlap(schItem?.times).filter(filterItem => {
                                                                  return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                                }).length > 0
                                                            }
                                                            onChange={(hour:boolean, time)=>{
                                                              const c = cloneDeep(weekItem);
                                                              const value = item?.startTime?.split(":");
                                                              if(hour) {
                                                                value[0] = time
                                                              }else {
                                                                value[1] = time
                                                              }
                                                              c[schIndex].times[index].startTime = `${value[0]}:${value[1]}`

                                                              setWeekItem(cloneDeep(c))
                                                            }}
                                                />
                                                <div className="line"></div>
                                                <PickerWrap
                                                    time={item?.endTime}
                                                    warn={
                                                        item?.startTime >= item?.endTime ||
                                                        findOverlap(schItem?.times).filter(filterItem => {
                                                          return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                        }).length > 0
                                                    }
                                                    onChange={(hour:boolean, time)=>{
                                                      const c = cloneDeep(weekItem);
                                                      const value = item?.endTime.split(":");

                                                      if(hour) {
                                                        value[0] = time
                                                      }else {
                                                        value[1] = time
                                                      }
                                                      c[schIndex].times[index].endTime = `${value[0]}:${value[1]}`

                                                      setWeekItem(cloneDeep(c))
                                                    }}
                                                />
                                                <div
                                                    onClick={() => {
                                                      onClickWeekItem(false, schItem?.dayOfWeek, index);
                                                    }}
                                                    className="delIcon icon">
                                                  <DeleteIcon/>
                                                </div>
                                              </InputItems>
                                              <AddButton
                                                  onClick={()=>{
                                                    onClickWeekItem(true, schItem?.dayOfWeek, null);
                                                  }}
                                                  className={`icon ${index === 0 ? "on" : ""}`}>
                                                <PlusIcon/>
                                              </AddButton>
                                            </WeeklyItem>
                                            {
                                                item?.startTime >= item?.endTime &&
                                                <p style={{
                                                  color:"rgb(215,47,41)",
                                                  marginLeft:160,
                                                  marginBottom:10
                                                }}>Choose en end time later the start Time</p>
                                            }
                                            {
                                                findOverlap(schItem?.times).filter(filterItem => {
                                                  return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                }).length > 0 &&
                                                // (checkOverlapSetting(schItem?.times, item?.startTime, true) > 1 ||
                                                // checkOverlapSetting(schItem?.times, item?.endTime, false) > 1) &&
                                                <p style={{
                                                  color: "rgb(215,47,41)",
                                                  marginLeft: 160,
                                                  marginBottom: 10
                                                }}>Times overlap with another set of times</p>
                                            }
                                          </React.Fragment>
                                      )
                                    })
                              }
                            </DaySch>
                        )
                      })
                    }
                  </WeeklyList>

                </WeeklyItems>
                <PopupSave style={{padding:"0 20px 0 0"}}>
              <span
                  onClick={()=>{
                    const c = cloneDeep(prevWeeklyData)
                    setWeeklyPopup(false)
                    setWeekItem(c)
                  }}
              >Cancel</span>
                  <span
                      onClick={()=>{
                        setWeeklyPopup(false)
                      }}
                  >Apply</span>
                </PopupSave>
              </PopupArea>
            </Overlay>
        }
        {
          configPopup &&
          <Overlay filter={true}>
            <PopupArea>
              <Contents title={"Scheduling Setting"}>
                <ConfigPopup>
                  <DropDownItem>
                    <DropDownTop>
                      <h4>Buffer Time</h4>
                      <span
                          onClick={() => {
                            setBufferTime(0)
                          }}
                      >None</span>
                    </DropDownTop>
                    <DropDownContents>
                      <DropdownMenu
                          altText="Select time"
                          selected={bufferTime === 0 ? "" : `${padZero(bufferTime)} min`}
                          onClick={(...item)=>{

                            setBufferTime(Number(item[3]?.item))
                          }}
                          items={[...getConfigMinArr()]}/>
                    </DropDownContents>
                    <p>
                      Add time before or after booked events
                    </p>
                  </DropDownItem>

                  <DropDownItem>
                    <DropDownTop>
                      <h4>Daily Limit</h4>
                      <span
                        onClick={()=>{
                          setDailyLimit(0)
                        }}
                      >None</span>
                    </DropDownTop>
                    <DropDownContents>
                      <FormItem className={"form"}>
                        <input
                            onChange={(event)=>{
                              const value = event.target.value;
                              const regex = /^[0-9]*$/;
                              if (regex.test(value)) {
                                setDailyLimit(Number(value));
                              }
                            }}
                            placeholder={"event limits"}
                            value={dailyLimit !== 0 ? dailyLimit : ""}
                            // value={time.endTime === "00" && time.startTime === "00" ? "" : `${time.startTime} : ${time.endTime}`}
                        />
                      </FormItem>
                      <span className={"guideText"}>
                      Events max per day
                    </span>
                    </DropDownContents>
                    <p>
                      Add time before or after booked events
                    </p>
                  </DropDownItem>

                  <DropDownItem>
                    <DropDownTop>
                      <h4>Start time increments</h4>
                      <span
                        onClick={()=>{
                          setIncrements(0)
                        }}
                      >Not select</span>
                    </DropDownTop>
                    <b>Show available starts time in increments of...</b>
                    <DropDownContents>
                      <DropdownMenu
                          altText="Select time"
                          selected={isNaN(increments) ? "Custom" : increments === 0 ? "" : `${padZero(increments)} min`}
                          onClick={(...item)=>{

                            setIncrements(Number(item[3]?.item))
                          }}
                          items={[...getConfigMinArr(),{item:"custom", dropdownItem:"Custom"}]}/>
                    </DropDownContents>
                    {
                        isNaN(increments)&&
                        <DropDownContents style={{marginTop:10}}>
                        <FormItem className={"form customForm"} style={{
                          width:"60%!important"
                        }}>
                          <input
                              onChange={(event)=>{
                                const value = event.target.value;
                                const regex = /^[0-9]*$/;
                                if (regex.test(value)) {
                                  setCustomIncrements({
                                    ...customIncrements,
                                    value: Number(value)
                                  });
                                }
                              }}
                              value={customIncrements.value}
                              // value={time.endTime === "00" && time.startTime === "00" ? "" : `${time.startTime} : ${time.endTime}`}
                          />
                        </FormItem>
                        <DropdownMenu
                            altText="Min"
                            selected={customIncrements.type}
                            onClick={(item)=>{

                              setCustomIncrements({
                                ...customIncrements,
                                type:item
                              })
                            }}
                            items={["Min", "Hour"]}/>
                      </DropDownContents>
                    }
                    <p>
                      Set the frequency of available time slots for invitees.
                    </p>
                  </DropDownItem>
                  <div
                      onClick={()=>{
                        setConfigPopup(false)
                      }}
                      className="close">
                    <CloseIcon/>
                  </div>
                  <div className="configSave">
                    <span
                        onClick={async ()=>{
                          await putTimeSetting();
                          setConfigPopup(false)
                        }}
                    >Save</span>
                  </div>
                </ConfigPopup>
              </Contents>
            </PopupArea>
          </Overlay>
        }
        <Inner>
          <ContentsWrap>
            <Contents title={"Time Settings"} >

              <Settings>
                <TopContents>

                  <TimeZone>
                    <span>Time Zone</span>
                    <p style={{position:"absolute", opacity:0}} ref={textRef}>{timezoneValue}</p>
                    <TimeZoneInput width={Number(totalWidthValue.toFixed(0)) + 5}>
                      <AutoComplete
                          options={timeZones}
                          placeholder={"time zone"}
                          value={`${timezoneValue}`}
                          required={false}
                          formType={true}
                          onChange={(value) => {

                            setTimezone(value)
                            // onChangeData(edu,index,"degreeType1", setEdu, value)
                          }}
                      />
                      <svg width="12" height="6" viewBox="0 0 12 6" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M5.66546 4.18911L1.38268 0.22071C1.06544 -0.0735711 0.553137 -0.0735712 0.235998 0.22071C0.0844274 0.360665 -0.000856877 0.551565 -0.000856894 0.750676C-0.000856912 0.949786 0.0844273 1.14069 0.235998 1.28064L5.09127 5.77901C5.40821 6.07366 5.92091 6.07366 6.23785 5.77901L11.0932 1.28083C11.2448 1.14069 11.3301 0.949787 11.3301 0.750677C11.3301 0.551566 11.2448 0.360666 11.0932 0.220524C10.7759 -0.0735703 10.2637 -0.0733839 9.94644 0.220897L5.66546 4.18911Z"
                              fill="#333333"/>
                      </svg>
                    </TimeZoneInput>


                    {/*<p><b>{timezoneSt}</b>*/}
                    {/*  <svg width="12" height="6" viewBox="0 0 12 6" fill="none"*/}
                    {/*       xmlns="http://www.w3.org/2000/svg">*/}
                    {/*    <path fill-rule="evenodd" clip-rule="evenodd"*/}
                    {/*          d="M5.66546 4.18911L1.38268 0.22071C1.06544 -0.0735711 0.553137 -0.0735712 0.235998 0.22071C0.0844274 0.360665 -0.000856877 0.551565 -0.000856894 0.750676C-0.000856912 0.949786 0.0844273 1.14069 0.235998 1.28064L5.09127 5.77901C5.40821 6.07366 5.92091 6.07366 6.23785 5.77901L11.0932 1.28083C11.2448 1.14069 11.3301 0.949787 11.3301 0.750677C11.3301 0.551566 11.2448 0.360666 11.0932 0.220524C10.7759 -0.0735703 10.2637 -0.0733839 9.94644 0.220897L5.66546 4.18911Z"*/}
                    {/*          fill="#333333"/>*/}
                    {/*  </svg>*/}
                    {/*</p>*/}
                  </TimeZone>
                  <ConfigArea>
                    <div className="configIcon"
                         onClick={async () => {
                           await getManageSchedule()
                               .then(res => {
                                 setConfigPopup(true)

                               })
                         }}
                    >
                      <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_582_25823" maskUnits="userSpaceOnUse" x="0" y="0"
                              width="25" height="26">
                          <path d="M0 0.5H25V25.5H0V0.5Z" fill="white"/>
                        </mask>
                        <g mask="url(#mask0_582_25823)">
                          <path
                              d="M12.5003 9.15884C10.3789 9.15884 8.65915 10.8786 8.65915 13C8.65915 15.1214 10.3789 16.8411 12.5003 16.8411C14.6217 16.8411 16.3415 15.1214 16.3415 13C16.3415 10.8786 14.6217 9.15884 12.5003 9.15884ZM23.2817 10.2589L22.2417 11.1151C21.0553 12.0917 21.0553 13.9083 22.2417 14.8849L23.2817 15.741C23.6502 16.0444 23.7454 16.5698 23.5067 16.9833L21.4531 20.5401C21.2144 20.9536 20.7118 21.1338 20.2648 20.9664L19.0033 20.4938C17.5644 19.9547 15.9912 20.863 15.7386 22.3787L15.5172 23.7074C15.4387 24.1783 15.0313 24.5234 14.5539 24.5234H10.4467C9.96936 24.5234 9.56193 24.1783 9.48347 23.7074L9.26198 22.3787C9.0094 20.863 7.4362 19.9547 5.99729 20.4938L4.73586 20.9664C4.28879 21.1338 3.7862 20.9536 3.54748 20.5401L1.49392 16.9833C1.25525 16.5698 1.35041 16.0444 1.71897 15.741L2.75901 14.8849C3.94528 13.9083 3.94528 12.0917 2.75901 11.1151L1.71897 10.2589C1.35041 9.95552 1.25525 9.43013 1.49392 9.0167L3.54748 5.45982C3.7862 5.04639 4.28879 4.86611 4.73586 5.03359L5.99729 5.50615C7.4362 6.04521 9.0094 5.13696 9.26198 3.62129L9.48347 2.29253C9.56193 1.82168 9.96936 1.47656 10.4467 1.47656H14.5539C15.0313 1.47656 15.4387 1.82168 15.5172 2.29253L15.7386 3.62129C15.9912 5.13696 17.5644 6.04521 19.0033 5.50615L20.2648 5.03359C20.7118 4.86611 21.2144 5.04639 21.4531 5.45982L23.5067 9.0167C23.7454 9.43013 23.6502 9.95552 23.2817 10.2589Z"
                              stroke="#333333" strokeWidth={"1.6"} strokeMiterlimit={"10"} strokeLinecap={"round"}
                              stroke-linejoin="round"/>
                        </g>
                      </svg>
                    </div>
                    <span
                        onClick={() => {
                          setView(false)
                        }}
                    >List view</span>&nbsp; &nbsp;
                    <span
                        onClick={() => {
                          setView(true)
                        }}
                    >Calendar View</span>
                    <div className={`slideBox ${view ? "right" : ""}`}>
                    </div>
                  </ConfigArea>
                </TopContents>
                <View className={`${!view ? "list" : "calendar"}`}>
                  <ViewItem className={`${!view ? "on" : ""}`}>
                    <TimeSettingArea>
                      <WeeklyItems>
                        <h4 style={{marginBottom: 10, marginTop: 20}}>Set Weekly hours</h4>
                        <WeeklyList>
                          {
                            weekItem?.map((schItem, schIndex) => {


                              return (
                                  <DaySch
                                      className={`${isEmpty(schItem?.times) ? "empty" : ""}`}
                                      style={{
                                        height: isEmpty(schItem?.times) ? 80 : schItem?.times?.length * 50 + 30
                                            + (checkTimeSetting(schItem.times) * 26 + (checkTimeSetting(schItem.times) !== 0 ? 8 : 0)) +
                                            (findOverlap(schItem.times).length * 26 + (findOverlap(schItem?.times)?.length !== 0 ? 8 : 0)),
                                        transition: "all 0.25s"
                                      }}
                                  >
                                    {
                                      isEmpty(schItem?.times) ?
                                          <WeeklyItem>
                                            <DayCheck className={"on"}
                                                      onClick={() => {
                                                        onClickCheckBox(schItem?.dayOfWeek)
                                                      }}
                                            >
                                              <CheckBox
                                                  onClick={() => {
                                                    onClickCheckBox(schItem?.dayOfWeek)
                                                  }}
                                                  state={returnCheckState(schItem?.dayOfWeek)}
                                              />
                                              <span>{textTransform().capitalizeFirstLetter(String(schItem?.dayOfWeek).toLocaleLowerCase())}</span>
                                            </DayCheck>

                                            <p>Not Available</p>
                                          </WeeklyItem>
                                          :
                                          schItem?.times?.map((item, index) => {
                                            return(
                                                <React.Fragment>
                                                  <WeeklyItem >
                                                    <DayCheck className={index === 0 ?"on" : ""}
                                                              onClick={()=>{
                                                                onClickCheckBox(schItem?.dayOfWeek)
                                                              }}
                                                    >
                                                      <CheckBox
                                                          onClick={()=>{
                                                            onClickCheckBox(schItem?.dayOfWeek)
                                                          }}
                                                          state={returnCheckState(schItem?.dayOfWeek)}
                                                      />
                                                      <span>{textTransform().capitalizeFirstLetter(String(schItem?.dayOfWeek).toLocaleLowerCase())}</span>
                                                    </DayCheck>
                                                    <InputItems>
                                                      <PickerWrap time={item?.startTime}
                                                                  warn={
                                                                      item?.startTime >= item?.endTime ||
                                                                      findOverlap(schItem?.times).filter(filterItem => {
                                                                        return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                                      }).length > 0
                                                                  }
                                                                  onChange={(hour:boolean, time)=>{
                                                                    const c = cloneDeep(weekItem);
                                                                    const value = item?.startTime?.split(":");
                                                                    if(hour) {
                                                                      value[0] = time
                                                                    }else {
                                                                      value[1] = time
                                                                    }
                                                                    c[schIndex].times[index].startTime = `${value[0]}:${value[1]}`

                                                                    setWeekItem(cloneDeep(c))
                                                                  }}
                                                      />
                                                      <div className="line"></div>
                                                      <PickerWrap
                                                          time={item?.endTime}
                                                          warn={
                                                              item?.startTime >= item?.endTime ||
                                                              findOverlap(schItem?.times).filter(filterItem => {
                                                                return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                              }).length > 0
                                                          }
                                                          onChange={(hour:boolean, time)=>{
                                                            const c = cloneDeep(weekItem);
                                                            const value = item?.endTime.split(":");

                                                            if(hour) {
                                                              value[0] = time
                                                            }else {
                                                              value[1] = time
                                                            }
                                                            c[schIndex].times[index].endTime = `${value[0]}:${value[1]}`

                                                            setWeekItem(cloneDeep(c))
                                                          }}
                                                      />
                                                      <div
                                                          onClick={() => {
                                                            onClickWeekItem(false, schItem?.dayOfWeek, index);
                                                          }}
                                                          className="delIcon icon">
                                                        <DeleteIcon/>
                                                      </div>
                                                    </InputItems>
                                                    <AddButton
                                                        onClick={()=>{
                                                          onClickWeekItem(true, schItem?.dayOfWeek, null);
                                                        }}
                                                        className={`icon ${index === 0 ? "on" : ""}`}>
                                                      <PlusIcon/>
                                                    </AddButton>
                                                  </WeeklyItem>
                                                  {
                                                      item?.startTime >= item?.endTime &&
                                                      <p style={{
                                                        color:"rgb(215,47,41)",
                                                        marginLeft:160,
                                                        marginBottom:10
                                                      }}>Choose en end time later the start Time</p>
                                                  }
                                                  {
                                                      findOverlap(schItem?.times).filter(filterItem => {
                                                        return filterItem.startTime == item.startTime && filterItem.endTime == item.endTime;
                                                      }).length > 0 &&
                                                      // (checkOverlapSetting(schItem?.times, item?.startTime, true) > 1 ||
                                                      // checkOverlapSetting(schItem?.times, item?.endTime, false) > 1) &&
                                                      <p style={{
                                                        color: "rgb(215,47,41)",
                                                        marginLeft: 160,
                                                        marginBottom: 10
                                                      }}>Times overlap with another set of times</p>
                                                  }
                                                </React.Fragment>
                                            )
                                          })
                                    }
                                  </DaySch>
                              )
                            })
                          }
                        </WeeklyList>
                      </WeeklyItems>
                      <CustomItems>
                        <CustomTopArea>
                          <h3>
                            Add custom schedules
                          </h3>
                          <AddChapter
                              className={"addNow"}
                              style={{
                                height: 38,
                                padding: 0
                              }}
                              onClick={() => {
                                const c = cloneDeep(customData)
                                setPrevData(c)
                                setCalPopup(true)
                                onClickMore(dayjs(new Date()).format("YYYY-MM-DD"))
                              }}
                          >
                            <PlusIcon/>
                            <span style={{
                              fontSize: 16
                            }}>Add now</span>
                          </AddChapter>
                        </CustomTopArea>
                        <CustomMain>
                          {
                            customData?.map(((item, index) => {
                              return(
                                  <React.Fragment>
                                    {
                                      item?.times?.map((timeItem, timeIndex) => {
                                        return(
                                            <CustomMainItem>
                                         <span>
                                          {dayjs(item?.date).format('D MMM YYYY')}
                                        </span>
                                              <div className="customTime">
                                          <span>
                                            {timeItem?.startTime} - {timeItem?.endTime}
                                          </span>
                                                <div
                                                    onClick={()=>{
                                                      addCustom(false, timeIndex, dayjs(item?.date).format("YYYY-MM-DD"))
                                                    }}
                                                    className="delCustom">
                                                  <DeleteIcon/>
                                                </div>
                                              </div>
                                            </CustomMainItem>
                                        )
                                      })
                                    }

                                  </React.Fragment>
                              )
                            }))
                          }
                        </CustomMain>
                      </CustomItems>
                    </TimeSettingArea>
                  </ViewItem>
                  <ViewItem className={`${view ? "on" : ""}`}>
                    <CalendarView
                        setCustomData={(data)=>{
                          sortCustom(data)
                        }}
                        onClickWeekPopup={()=>{
                          const c = cloneDeep(weekItem)
                          setPrevWeeklyData(c)
                          setWeeklyPopup(v => !v)
                        }}
                        onClickMore={onClickMore} customData={customData} weekItem={weekItem}  />
                  </ViewItem>
                </View>
              </Settings>

              <SaveBtn
                  className={checkData(weekItem)?.length > 0 ? "none" : ""}
              >
                <AddChapter
                    onClick={async ()=>{
                      if(checkData(weekItem)?.length > 0) return;
                      await putTimeSetting()
                    }}
                >
            <span
                onClick={async ()=>{

                  // await putTimeSetting();
                  // const arr = cloneDeep(weekItem)?.map((schItem, schIndex) => {
                  //   return schItem;
                  // });
                  // const checkArr = arr.times.filter((item) => {
                  //
                  // })
                }}
            >
              Save
            </span>
                </AddChapter>
              </SaveBtn>
            </Contents>
          </ContentsWrap>
        </Inner>
      </Container>
  )

}
export default ManageSchedule;

const Container = styled.div`
  position: relative;
  transition: all 0.2s;
  width: 100vw;
  height: 100vh;
  background: rgba(250, 249, 243, 1);
`;
const Logo =  styled.div<{width?:number}>`
   position: absolute;
  width: ${props => props.width * 100}%;
  left: 30px;
  top: 30px;
  transform: scale(0.8);
  .text{
    cursor: pointer;
    margin-top: 24px;
    svg{
      width: 28px;
    }
    display: flex;
    align-items: center;
    span{
      margin-left: 15px;
      font-family: Europa-Regular;
      font-size: 22px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      border-bottom: 2px solid rgba(51, 51, 51, 1)
    }
  }
  svg{
    width: 100%;
    height: auto;
  }
`
const SucPopup = styled.div`
  z-index: 99999;
  border: 1.6px solid rgba(18, 166, 94, 1);
  background: rgba(226, 255, 241, 0.85);
  width: 520px;
  height: 66px;
  position: absolute;
  left: 50%;
  top: 70px;
  transform: translateX(-50%);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
  svg{
    width: 20px;
    height: 20px;
  }
  animation: ${fadeIn2} 0.25s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`
const PopupArea = styled.div`
  position: relative;
  border-radius: 8px;
  transition: all 0.2s;
  //transform: scale(0.85) ;

  &.weeklyEdit{
    height: 633px;
    width: 603px;
    padding: 20px 4px 40px 24px;
  }
`
const PopupContents = styled.div`
  background: rgba(245, 245, 245, 1);
  padding: 15px 20px;
    
`
const ContentsList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`
const ContentsListItems = styled.div`
 
`
const PopupSave = styled.div`
  background: #fff;
  border-radius: 0 0 8px 8px;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .none{
    opacity: 0.5;
  }
  span{
    padding: 10px 0;
    justify-content: center;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    width: calc((100% - 20px) / 2);
    border: solid 1px #333;
    &:last-child{
      background: #333;
      color: #fff;
    }
  }
`
const SaveBtn = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
  &.none{
    opacity: 0.5;
    pointer-events: none;
  }
  & > div{
    width: 150px;
    color: #fff;
    span{
      pointer-events: none;
      font-size: 16px;
      opacity: 0.9;
    }
  }
`
const ConfigPopup = styled.div`
  width: 500px;
  padding: 20px;
  .configSave{
    font-family: Europa-Bold;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    span{
      cursor: pointer;
      color: #fff;
      background: rgba(221, 193, 96, 1);
      width: 134px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .close{
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 12px;
    svg{
      width: 25px;
      height: 25px;
    }
  }
  //overflow: auto;
`
const DropDownItem = styled.div`
  border:solid 1px rgba(51, 51, 51, 0.3); 
  padding: 20px 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  p{
    margin-top: 15px;
    font-family: Europa-Regular;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(51, 51, 51, 0.6);
  }
  b{
    display: flex;
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 5px;
  }
`
const DropDownTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
   span{
     cursor: pointer;
     font-family: Europa-Bold;
     font-size: 16px;
     font-weight: 700;
     line-height: 18px;
     letter-spacing: 0em;
     text-align: right;
     color: rgba(75, 133, 250, 1);   
   }
`
const DropDownContents = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .customForm{
    min-width: 70%!important;
    margin-right: 10px;
    flex: 1;
  }
  & > div{
    width: 100%;
    flex: 1;
  }
   .guideText{
     width: 35%;
     display: flex;
     justify-content: flex-end;
     font-family: Europa-Bold;
     font-size: 14px;
     font-weight: 700;
     line-height: 14px;
     letter-spacing: 0em;
     text-align: left;
     color: rgba(51, 51, 51, 1);
     cursor: default;
   }
`
const Inner = styled.div`
  position: relative;
  width: 1040px;
  left: 50%;
  top: 50%;
  height: 80%;
  max-height: 790px;
  overflow: hidden;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  box-shadow: 0px 0px 10px 0px rgba(221, 193, 96, 0.5);
  animation: ${fadeIn3} 0.35s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`
const ContentsWrap = styled.div`
   height: 100%;
  .timeContents{
    height: 100%;
  } 
`
const Settings = styled.div`
  padding: 20px;
  height: calc(100% - 100px);
`
const View = styled.div`
  display: flex;
  position: relative;
  height: calc(100% - 40px);
  overflow: hidden;
  width: calc(200% + 0px);
  flex: 1;
  transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  transform: translateX(-50%);
  //transform: none;
  &.list{
    transform: none;
  }
`
const ViewItem = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  transition: all 0.3s;
  opacity: 0;
  &.on{
    opacity: 1;
  }
  
`
const TopContents = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
`
const TimeZone = styled.div`
  display: flex;
  flex-direction: column;
  .liveAutoComplete{
  .dropdown-list{
    width: 200px;
  }
    p{
      opacity: 0;
      position: absolute;
    }
    input, p{
      height: 25px;
      align-items: center;
      font-family: Europa-Bold;
      color: rgba(75, 133, 250, 1);
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      border: none;
      padding: 0;
    }
  }
  span{
    font-family: Europa-Bold;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
  p{
    margin-top: 5px;
    cursor: pointer;
    b{
      margin-right: 10px;
    }
    display: flex;
    align-items: center;
    font-family: Europa-Bold;
    color: rgba(75, 133, 250, 1);
font-size: 16px;
font-weight: 700;
line-height: 20px;
letter-spacing: 0em;
text-align: left;

  }
`
const TimeZoneInput = styled.div<{width:number}>`
  display: flex;
  align-items: center;
  width: ${props => props.width + 15}px!important;
  position: relative;
  min-width: 100px;
  svg{
    pointer-events: none;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }
  input{
    width: 100%;
  }
`
const ConfigArea = styled.div`
  display: flex;
  background: rgba(245, 245, 245, 1);
  border-radius: 5px;
  position: relative;
  width: 248px;
  height: 32px;
  .configIcon{
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
  }
  .slideBox{
    transition: all 0.2s;
    z-index: 0;
    background: rgba(221, 193, 96, 1);
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 124px;
    border-radius: 5px;
    &.right{
      left: 50%;
    }
  }
  span{
      font-family: Europa-Bold;
      font-size: 13px;
      font-weight: 700;
      line-height: 12px;
      letter-spacing: 0em;
      text-align: left;
      z-index: 1;
    width: 124px;
    height: 32px;
    align-items: center;
    justify-content: center;
    display: flex;
    cursor: pointer;
  }
`
const TimeSettingArea = styled.div`
  padding-top: 0px;
  border-top: solid 2px rgba(51, 51, 51, 0.2);
  display: flex;
  width: 100%;
  position: relative;
  height: 100%;
`
const WeeklyItems = styled.div`
  flex: 1;
  position: relative;
  height: calc(100% - 40px);
`
const WeeklyList = styled.div`
  height: 100%;
  overflow-y: scroll;
  padding-right: 20px;

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(51, 51, 51, 0.3);
    border: none;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border: none;
  }
`
const DaySch = styled.div`
  border-bottom: 0.6px solid rgba(51, 51, 51, 0.3);
  &:last-child{
    border-bottom: none!important;
  }
  padding-top: 20px;
  &.empty{
    padding-top: 10px;
    display: flex;
    align-items: center;
  }
`
const WeeklyItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  animation: ${fadeIn} 0.25s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
  &.calPopup{
    display: flex;
    flex-direction: column;
    
  }
  p{
    font-family: Europa-Regular;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
  }
`
const DayCheck = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  width: 140px;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  &.on{
    opacity: 1;
    pointer-events: all;
  }
  span{
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }
`
const InputItems = styled.div`
  display: flex;
  align-items: center;
  .form{
    display: flex;
    align-items: center;
    //position: absolute;
    width: 100%;
  }
  .delIcon{
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
  }
  input{
    display: flex;
    text-align: center;
    height: 40px;
    width: 100px;
    border-radius: 4px;
    font-weight: 600;
  }
  .line{
    width: 10px;
    height: 2px;
    background: #333;
    margin: 0 20px;
  }
  .icon {
    svg{
      width: 20px;
      height: 20px;
      transform: scale(1.1);
      path{
        fill: #333;
      }
    }
  }
`
const PickerPopup = styled.div`
  position: absolute;
  width: 250px;
  background:#fff;
  display: flex;
  box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 9999;
  border-radius: 8px;
  align-items: center;
  top: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transform-origin: left top;
  transition: all 0.25s;
  transform: scale(0.5) ;
  &.on{
    transform-origin: left top;
    opacity: 1;
    transform: none;
    pointer-events: all;
  }
`
const AddButton = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  opacity: 0;
  pointer-events: none;
  &.on{
    opacity: 1;
    pointer-events: all;
  }
  svg{
    width: 20px;
    height: 20px;
    path{
      fill: #333;
    }
  }
`
const CustomItems = styled.div`
  width: 35%;
 
  border-left: solid 2px rgba(51, 51, 51, 0.2);
  .addNow{
    margin-top: 30px;
    width: 100%;
    span{
      opacity: 0.9;
    }
    svg{
      width: 18px;
      height: 18px;
      padding-bottom: 2px;
      margin-right: 10px;
    }
  }
`
const CustomTopArea = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px 20px 0px 20px;
`
const CustomMain = styled.div`
  height: calc(100% - 140px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(51, 51, 51, 0.3);
    border: none;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border: none;
  }
`
const CustomMainItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:20px 15px;
  border-bottom: 0.6px solid rgba(51, 51, 51, 0.3);
  .customTime{
    display: flex;
    align-items: center!important;
    vertical-align: center;
    span{
      margin-right: 20px;
      font-size: 15px;
      font-weight: 600;
    }
  }
  .delCustom{
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
  }
  span{
    font-size: 15px;
    font-weight: 600;
  }
  svg{
    width: 20px;
    height: 20px;
    transform: scale(1.1);
    path{
      fill: #333;
    }
  }
`